<ejs-tooltip id="tooltip" target="#toolbar [title]" [animation]="tooltipAnimation">
  <ejs-toolbar id="toolbar" class="tree-view-toolbar">
    <e-items>
      <e-item prefixIcon="icon-collapse-all e-primary"
              (click)="onCollapseAll()"
              tooltipText="{{ 'i18n.domain.administration.tooltips.collapse' | translate }}">
      </e-item>
      @if (canAddStructuralEntry) {
        <e-item
              text="{{iconTextCodes.folderIcon}}"
              (click)="onAddStructuralEntry()"
              prefixIcon="icon-add e-primary"
              tooltipText="{{ 'i18n.domain.administration.tooltips.add-folder' | translate }}"></e-item>
      }
      @if (canRemoveStructuralEntry) {
        <e-item
              text="{{iconTextCodes.folderIcon}}"
              (click)="onRemoveStructuralEntry()"
              prefixIcon="icon-subtract e-primary"
              tooltipText="{{ 'i18n.domain.administration.tooltips.remove-folder' | translate }}"></e-item>
      }
      @if (canAddSubscription) {
        <e-item
              text="{{iconTextCodes.subscriptionIcon}}"
              (click)="onAddSubscription()"
              prefixIcon="icon-add e-primary"
              tooltipText="{{ 'i18n.domain.administration.tooltips.add-subscription' | translate }}"></e-item>
      }
      @if (canRemoveSubscription) {
        <e-item
              text="{{iconTextCodes.subscriptionIcon}}"
              (click)="onRemoveSubscription()"
              prefixIcon="icon-subtract e-primary"
              tooltipText="{{ 'i18n.domain.administration.tooltips.remove-subscription' | translate }}"></e-item>
      }
      @if (canAddTariff) {
        <e-item
              text="{{iconTextCodes.tariffIcon}}"
              (click)="onAddTariff()"
              prefixIcon="icon-add e-primary"
              tooltipText="{{ 'i18n.domain.administration.tooltips.add-tariff' | translate }}"></e-item>
      }
    </e-items>
  </ejs-toolbar>
</ejs-tooltip>
<ejs-treeview #tree
              [fields]="treeViewFieldSetting"
              class="template-tree"
              height="100%"
              [allowDragAndDrop]='true'
              (nodeSelected)="onNodeSelected($event)"
              (nodeDragStop)="onNodeDragStop($event)"
              (nodeDragging)="onNodeDragging($event)"
              (nodeDragStart)="onNodeDragStart($event)">
  <ng-template #nodeTemplate
               let-data>
    <div>
      <div class="treeviewdiv">
        <div class="textcontent" [ngClass]="{'item-inactive': data.itemData.inactive}">
          @if (hasIcon(data.itemData.type)) {
            <span class="treeIcon" [ngClass]="getTreeItemClasses(data.itemData)"></span>
          }
          <span class="treeName" [ngClass]="{'item-highlighted': data.itemData.isHighlighted}">{{data.itemData.name | translate}}</span>
        </div>
      </div>
    </div>
  </ng-template>
</ejs-treeview>
